import { Box, Checkbox, Text } from '@factorialco/deprecated-design-system'

import Selector from 'modules/core/components/Selector'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import type BulkEditForm from 'modules/employees/pages/EditInBulk/forms/BulkEdit'
import { CustomField } from 'modules/employees/pages/EditInBulk/types'

interface Props {
  bulkEditForm: BulkEditForm
  isChecked: boolean
  onChange: (value: string) => void
  onClick: () => void
  width?: string
  customFieldId: number
  customField: CustomField
}

const CustomFieldSingleChoice = ({
  bulkEditForm,
  onChange,
  onClick,
  isChecked,
  width,
  customFieldId,
  customField,
}: Props) => {
  const value = bulkEditForm.get(customFieldId.toString())?.value

  const onHandleChange = (selectedValue: unknown) => {
    bulkEditForm.setValues({
      [customFieldId]: selectedValue,
    })
    onChange(typeof selectedValue === 'string' ? selectedValue : value)
  }

  const customFieldOptions = useUnsafeMemo(() => {
    return customField.options.map(({ id, label, isActive }) => {
      return {
        id,
        label,
        isActive,
      }
    })
  }, [customField.options])

  return (
    <Box
      background="grey000White"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      height="full"
      paddingX="s16"
      paddingY="s12"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey000White',
        },
      }}
      gap="s16"
      style={{ width }}
    >
      <Box flexNoShrink>
        <Checkbox checked={isChecked} onChange={onClick} />
      </Box>
      {!!customFieldOptions?.length && (
        <Selector.Popover
          blankLabel={i18n.t('common.empty')}
          allSelectedLabel={i18n.t('common.all')}
          placeholder={i18n.t('common.select')}
          searchPlaceholder={i18n.t('common.search')}
          value={value ? [value] : []}
          onChange={onHandleChange}
        >
          {customFieldOptions?.map((customFieldOption) => (
            <Selector.Option
              key={customFieldOption.id}
              label={customFieldOption.label || ''}
              searchValue={customFieldOption.label || ''}
              value={customFieldOption.label}
              isDisabled={!customFieldOption.isActive}
            >
              <Box width="full" overflowY="hidden">
                <Text.Normal size="200" weight="medium" ellipsis>
                  {customFieldOption.label}
                </Text.Normal>
              </Box>
            </Selector.Option>
          ))}
        </Selector.Popover>
      )}
    </Box>
  )
}

export default CustomFieldSingleChoice
